/**
 * The fields of `UserDto` that decide super admin powers. Structural, so the
 * helpers accept the login response user and `GET /users/me` alike.
 */
export interface SuperpowerUser {
  services?: { superpowers?: { activated?: boolean | null } | null } | null;
  mfaEnabled?: boolean | null;
  mfaMethods?: readonly string[] | null;
}

function hasMfa(user: SuperpowerUser): boolean {
  return (user.mfaMethods?.length ?? 0) > 0 || user.mfaEnabled === true;
}

/** The account carries the super admin flag, whatever its MFA state. */
function hasSuperpowerFlag(user: SuperpowerUser | null | undefined): boolean {
  return user?.services?.superpowers?.activated === true;
}

/**
 * Super admin powers are only granted to a flagged account that has MFA
 * enabled (BAB-3035): without it the account behaves as a regular one.
 */
export function hasActiveSuperpower(
  user: SuperpowerUser | null | undefined,
): boolean {
  return !!user && hasSuperpowerFlag(user) && hasMfa(user);
}

/** Flagged, but powers stay off until the account enables MFA. */
export function isSuperpowerAwaitingMfa(
  user: SuperpowerUser | null | undefined,
): boolean {
  return !!user && hasSuperpowerFlag(user) && !hasMfa(user);
}
